
import Vue from 'vue'
import Stats from '@/components/contest/Stats.vue'
import ContestList from '@/components/contest/ContestList.vue'
import { Statistics } from '@/model/Statistics'

export default Vue.extend({
  name: 'Contests',
  components: {
    Stats,
    ContestList,
  },
  props: {
    filter: {
      type: String,
    },
  },
  mounted() {
    this.fetchStatistics()
    this.fetchCounters()
  },
  computed: {
    margin: function (): number {
      if (this.$vuetify.breakpoint.xs) {
        return 370
      }

      if (this.$vuetify.breakpoint.sm) {
        return 165
      }

      return 60
    },
  },
  data: () => ({
    openContestsCounter: 0,
    finishedContestsCounter: 0,
    comingSoonContestsCounter: 0,
    stats: [] as Statistics[],
    isTournamentAvailable: process.env.VUE_APP_IS_TOURNAMENT_AVAILABLE === 'true',
  }),
  methods: {
    fetchStatistics: function () {
      if (this.isTournamentAvailable) return;

      this.$api.get('/contests/statistics').then((response) => {
        this.stats = [
          {
            value: response.data.rewardsSum + ' USD',
            icon: 'mdi-trophy',
            name: 'sum of<br>prizes',
          },
          {
            value: response.data.projectsCount,
            icon: 'mdi-counter',
            name: 'submitted<br>projects',
          },
          {
            value: response.data.usersCount,
            icon: 'mdi-account-group',
            name: 'total number of<br>participants',
          },
          {
            value: response.data.winnersCount,
            icon: 'mdi-seal',
            name: 'total number of<br>winners',
          },
        ]
      })
    },
    fetchCounters: function () {
      const apiCountersPromises = []

      apiCountersPromises.push(
        this.$api.get('/contests/counts').then((response) => {
          this.openContestsCounter = response.data['open']
          this.finishedContestsCounter = response.data['closed']
          this.comingSoonContestsCounter = response.data['comingSoon']
        })
      )

      return Promise.allSettled(apiCountersPromises)
    },
  },
})
